module OnlineDPR.Application.Client.Report.Types

open OnlineDPR.Application.Shared

type Msg =
| ParseModelData of Result<ReportViewModel, string>
| ParseMenu of Result<ReportMenuEntry, exn>
| BindMenu
| ToggleCategoryVisibility of ReportCategory
| ToggleCategoryCheckbox of ReportCategory
| UpdateFilter of ReportFilterViewModel
| ReloadModel
| UpdateChartOptions of ReportChartOptions
| EditDprClubSelected of Field
| EditDprDateSelected of Field
| ToggleShowEditDpr
| ToggleShowChart
| EditDprRequested
| EditDprResponded of Result<EditRequestResult, string>

let invalidDatapoint  = 0.00001m